import { z } from 'zod';
import { dayTimeValues } from '../../workout/components/Schedule';
import { optionalString } from '@client/pages/CustomProgramPage/zod-helpers';
import {
  DEFAULT_PHOTO_INSTRUCTIONS,
  DEFAULT_POSES,
  DEFAULT_POSE_GENDER,
} from '../pose-guide.constants';

const number = (min: number, max: number) => z.number().min(min).max(max);

export const dateTimeSchema = z.object({
  dateTimestamp: z.number().nullable(),
  dateHour: number(0, 12),
  dateMinute: number(0, 59),
  dateDayTime: z.union([z.enum(dayTimeValues), z.literal('')]),
});

export type DateTimeSchema = z.infer<typeof dateTimeSchema>;

export const challengeSchema = z.object({
  name: optionalString(),
  registrationStart: dateTimeSchema,
  registrationEnd: dateTimeSchema,
  completionStart: dateTimeSchema,
  completionEnd: dateTimeSchema,
  showPhotosSection: z.boolean(),

  submissionRequirements: z.object({
    instagram: z.boolean(),
    goal: z.boolean(),
    phoneNumber: z.boolean(),
    photos: z.boolean(),
  }),

  completionRequirements: z.object({
    testimonial: z.boolean(),
    photos: z.boolean(),
  }),

  photoInstructions: z.string().optional(),
  photoGuide: z
    .array(
      z.object({
        imageUrl: z.string(),
        name: z.string().max(24),
      }),
    )
    .optional(),
  templates: z.array(z.string()),
});

export type ChallengeForm = z.infer<typeof challengeSchema>;
const emptyDateTime = (dateMinute = 0): DateTimeSchema => ({
  dateTimestamp: null,
  dateHour: 0,
  dateMinute,
  dateDayTime: 'AM',
});
export const emptyChallenge: ChallengeForm = {
  name: '',
  registrationStart: emptyDateTime(),
  registrationEnd: emptyDateTime(),
  completionStart: emptyDateTime(),
  completionEnd: emptyDateTime(),
  showPhotosSection: true,
  submissionRequirements: {
    instagram: false,
    goal: false,
    phoneNumber: false,
    photos: false,
  },
  completionRequirements: {
    testimonial: false,
    photos: false,
  },
  photoInstructions: DEFAULT_PHOTO_INSTRUCTIONS,
  photoGuide: DEFAULT_POSES[DEFAULT_POSE_GENDER],
  templates: [],
};
